'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ImageFileInput = require('../../components/tools/images/ImageFileInput');

var _ImageFileInput2 = _interopRequireDefault(_ImageFileInput);

var _Icon = require('../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


var ImageUploaderContent = function (_React$Component) {
    _inherits(ImageUploaderContent, _React$Component);

    function ImageUploaderContent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ImageUploaderContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageUploaderContent.__proto__ || Object.getPrototypeOf(ImageUploaderContent)).call.apply(_ref, [this].concat(args))), _this), _this.openFileSelect = function (event) {
            var fileInput = _this.refs.fileInput;

            var fileInputDomNode = _reactDom2.default.findDOMNode(fileInput);
            fileInputDomNode.click();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Delegates the click event on the fake file upload input to the real, hidden one.
     */


    _createClass(ImageUploaderContent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                uploadImage = _props.uploadImage,
                elementId = _props.elementId;


            return _react2.default.createElement(
                'div',
                { className: 'uploader-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'click-area', onClick: this.openFileSelect },
                    _react2.default.createElement(_ImageFileInput2.default, { ref: 'fileInput', id: elementId, uploadImage: uploadImage }),
                    _react2.default.createElement(_Icon2.default, { name: 'image-form-upload' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'cta' },
                        'Upload an image'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'hint' },
                    'Tip: You can drag and drop images straight from your desktop.'
                )
            );
        }
    }]);

    return ImageUploaderContent;
}(_react2.default.Component);

ImageUploaderContent.propTypes = {
    elementId: _propTypes2.default.string,
    uploadImage: _propTypes2.default.func
};

exports.default = ImageUploaderContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/ImageUploaderContent.js
// module id = 1983
// module chunks = 0